import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { apiFetch } from '../../api/api';

export function galleryQrUrl(value) {
  if (typeof value !== 'string' || value !== value.trim()) return null;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' && !parsed.username && !parsed.password ? value : null;
  } catch (_) { return null; }
}

// Only newly generated QR destinations change; existing repository links remain valid.
export default function GalleryDownloadQr({ url, galleryId, dataDocId, kind='photo' }) {
  const [result, setResult] = useState(null);
  const [failed, setFailed] = useState(false);
  const [revision,refresh]=useState(0);
  useEffect(() => {
    let cancelled = false;
    setResult(null);
    setFailed(false);
    let timer;
    if ((kind==='video'||kind==='capture-photo'||galleryQrUrl(url)) && galleryId && dataDocId) {
      (async()=>{
        const share=await apiFetch('/gallery/photo-share',{method:'POST',body:{galleryId,dataDocId,...(kind==='video'?{kind}: {})}});
        const expiry=Date.parse(share.expiresAt);
        if(!share.token || !Number.isFinite(expiry) || expiry<=Date.now())throw new Error('Invalid photo access');
        const value=`${window.location.origin}/gallery/photo#${encodeURIComponent(share.token)}`;
        const image=await QRCode.toDataURL(value, { width: 220, margin: 4, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#ffffff' } });
        if(!cancelled){setResult({url,galleryId,dataDocId,image});timer=setTimeout(()=>{setResult(null);setFailed(true);},Math.max(0,expiry-Date.now()));}
      })().catch(()=>{if(!cancelled){setResult(null);setFailed(true);}});
    }
    return () => { cancelled = true; clearTimeout(timer); };
  }, [url,galleryId,dataDocId,revision,kind]);
  if(failed)return <div><p role="status">{kind==='video'?'Video':'Photo'} sharing unavailable or expired.</p><button type="button" className="btn-blue" onClick={()=>refresh(n=>n+1)}>Refresh QR</button></div>;
  return result && result.url === url && result.galleryId===galleryId && result.dataDocId===dataDocId ? <div className="gallery-download-qr"><img src={result.image} alt={`Scan to share or download this ${kind==='capture-photo'?'photo':kind}`} width="220" height="220" /><span>Scan to share or download photo · valid for 15 minutes</span></div> : null;
}
